import { render } from "./ButtonControl.vue?vue&type=template&id=9674c7f6"
import script from "./ButtonControl.vue?vue&type=script&lang=js"
export * from "./ButtonControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__